import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
export function PurchaseNotification() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const show = window.setTimeout(() => setVisible(true), 5000);
    const hide = window.setTimeout(() => setVisible(false), 15000);
    return () => {
      window.clearTimeout(show);
      window.clearTimeout(hide);
    };
  }, []);
  return <AnimatePresence data-id="element-279" data-mp="21xtskxqc5oi0">
      {visible && <motion.aside initial={{
      opacity: 0,
      y: 24
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 16
    }} className="fixed bottom-4 right-4 z-50 w-[calc(100%-2rem)] max-w-sm rounded-xl border border-sand/50 border-l-4 border-l-earth bg-surface p-4 pr-10 shadow-lift" aria-live="polite" data-id="element-280" data-mp="21y3g8enwrjkj">
          <button onClick={() => setVisible(false)} className="absolute right-2 top-2 rounded p-1 text-muted hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-gold" aria-label="Cerrar aviso" data-id="element-281" data-mp="hh79094z3k8n">
            <XIcon className="h-4 w-4" data-id="element-282" data-mp="1xcwlv0dxxl1h" />
          </button>
          <div className="flex gap-3" data-id="element-283" data-mp="1je6ij30j2p4o">
            <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-earth" data-id="element-284" data-mp="1jhauwno5cr6f" />
            <div data-id="element-285" data-mp="1nf8jppe09b9a">
              <p className="text-[10px] font-extrabold uppercase tracking-[.16em] text-earth" data-id="element-286" data-mp="1niw8kb8i99ho">Acceso confirmado</p>
              <p className="mt-1 text-sm leading-snug text-white" data-id="element-287" data-mp="1eg4yaerd8jrm">
                <strong data-id="element-288" data-mp="1ehg22ekt9riq">Una docente de Córdoba</strong> eligió el
                <br data-id="element-289" data-mp="zsa3mstss5bw" />
                <span className="font-bold text-gold" data-id="element-290" data-mp="zstmcbr9uxqz">Megapack Bromatología Premium</span>
              </p>
              <p className="mt-2 text-xs text-muted" data-id="element-291" data-mp="14qldv4o08hun">Hace unos minutos</p>
            </div>
          </div>
        </motion.aside>}
    </AnimatePresence>;
}